import { CoopLogoIcon } from '@coop/icons';
import classnames from 'classnames';

import { appConfig } from '../../../../appConfig';
import { UserType } from '../../../common/flow/user/userModels';
import { useUserTypeQuery } from '../../../common/hooks/useUserQueries';

interface BannerProps {
    headerTheme: 'black' | 'darkGreen';
    bordered?: boolean;
    wideSlots?: boolean;
}

const Logo = () => {
    const { data: userType } = useUserTypeQuery();
    const isPunchout = userType === UserType.punchout;

    return (
        <a
            className={classnames('Header-logo')}
            href={
                appConfig.coopUserSettings.isShoppingForAnother || isPunchout
                    ? appConfig.coopSettings.ecommerce.page.url
                    : appConfig.coopSettings.startPage.url
            }
            aria-label="Till startsidan"
        >
            <CoopLogoIcon aria-hidden style={{ fill: 'currentColor' }} />
        </a>
    );
};

const Banner = (props: React.PropsWithChildren<BannerProps>) => {
    return (
        <div
            className={classnames(
                'HeaderBanner',
                'u-noPrint',
                props.wideSlots && 'HeaderBanner--wideSlots',
                props.bordered && 'HeaderBanner--bordered',
                props.headerTheme === 'darkGreen' && 'HeaderBanner--darkGreen',
                props.headerTheme === 'black' && 'HeaderBanner--black',
            )}
            style={{ zIndex: 2 }}
        >
            {props.children}
        </div>
    );
};

const LeftSlot = (props: React.PropsWithChildren<{ narrow?: boolean }>) => {
    return (
        <div
            className={classnames('HeaderBanner-Left', props.narrow && 'HeaderBanner-Left--narrow')}
        >
            {props.children}
        </div>
    );
};

const LeftNav = (props: React.PropsWithChildren<{}>) => {
    return <div className="HeaderBanner-LeftNav">{props.children}</div>;
};

const RightNav = (props: React.PropsWithChildren<{}>) => {
    return <div className="HeaderBanner-RightNav">{props.children}</div>;
};

const CenterSlot = (props: React.PropsWithChildren<{}>) => {
    return <div className="HeaderBanner-Center">{props.children}</div>;
};

const RightSlot = (props: React.PropsWithChildren<{ narrow?: boolean }>) => {
    return (
        <div
            className={classnames(
                'HeaderBanner-Right',
                props.narrow && 'HeaderBanner-Right--narrow',
            )}
        >
            {props.children}
        </div>
    );
};

const HeaderBanner = {
    Logo,
    Banner,
    LeftSlot,
    LeftNav,
    RightNav,
    CenterSlot,
    RightSlot,
};

export default HeaderBanner;
